"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputStyles = exports.style = void 0;
exports.style = {
    backgroundColor: "transparent !important",
};
exports.inputStyles = {
    "& .MuiOutlinedInput-root": {
        backgroundColor: "#fff",
    },
};
